import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { convertToUpperCase } from 'helper';

function DocumentInformation({
  taxpayer,
  transactionInfo,
}) {
  const spanGap = 8;
  const transactionType = get(transactionInfo, 'attributes.transaction_type')
  const bornAbroad = get(transactionInfo, 'included.module.attributes.born_abroad_country_name');

  return (
    <>
      <div className='p-3' style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  APPLICATION INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Registry Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'registry_number') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Number of Copies
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'number_of_copies') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Purpose
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{convertToUpperCase(get(taxpayer, 'purpose_name'))}</b>
              </td>
            </tr>
            {transactionType !== 'DEATH CERTIFICATE' && (
              <>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Registered Late
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {get(taxpayer, 'is_registered_late') === '1'
                        || get(taxpayer, 'is_registered_late') === 1 
                          ? 'YES' : 'NO' 
                          || '--'
                      }
                    </b>
                  </td>
                </tr>
                {get(taxpayer, 'is_registered_late') === '1' && ( 
                  <>
                    <tr>
                      <td className="text-dark" colSpan={spanGap}>
                        Registered Date
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {moment(_.get(taxpayer, 'registered_when')).format('MMMM DD, YYYY') || '--'}
                        </b>
                      </td>
                    </tr>
                  </>
                )}
              </>
            )}
            {transactionType === 'BIRTH CERTIFICATE' && (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Date of Birth
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {moment(_.get(taxpayer, 'birth_date')).format('MMMM DD, YYYY') || '--'}
                  </b>
                </td>
              </tr>
            )}
            {transactionType === 'DEATH CERTIFICATE' && (
              <>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Date of Death
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {moment(_.get(taxpayer, 'death_date')).format('MMMM DD, YYYY') || '--'}
                    </b>
                  </td>
                </tr>
              </>
            )}
            {transactionType === 'MARRIAGE CERTIFICATE' && (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Date of Marriage
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td>
                  <b>
                    {_.get(taxpayer, 'date_marriage')
                      ? moment(_.get(taxpayer, 'date_marriage')).format('MMMM DD, YYYY')
                      : ''}
                  </b>
                </td>
              </tr>
            )}

            {transactionType !== 'MARRIAGE CERTIFICATE' && (
              <>
                <tr className='mt-3'>
                  <td width="350">
                    <span className="title" style={{ fontSize: '16px' }}>
                      DOCUMENT OWNER'S PERSONAL INFORMATION
                    </span>
                  </td>
                </tr> 

                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    First Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'first_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Middle Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'middle_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Last Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'last_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Extension Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'extension_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Sex
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'gender'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Hospital Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'hospital_name'))}
                    </b>
                  </td>
                </tr>
                {bornAbroad ? (
                  <tr>
                    <td className="text-dark" colSpan={spanGap}>
                      Born Abroad
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {convertToUpperCase(bornAbroad || '--')}
                      </b>
                    </td>
                  </tr>
                ) : null}
                {_.get(taxpayer, 'hospital_name') === 'OTHER' && (
                  <tr>
                    <td className="text-dark" colSpan={spanGap}>
                      Name of Hospital Other
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {convertToUpperCase(_.get(taxpayer, 'hospital_other'))}
                      </b>
                    </td>
                  </tr>
                )}
                {transactionType === 'BIRTH CERTIFICATE' && (
                  <tr>
                    <td className="text-dark" colSpan={spanGap}>
                      Place of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_birth_municipality_name')
                        )}
                        ,{' '}
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_birth_province_name')
                        )}
                        ,{' '}
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_birth_region_name')
                        )}{' '}
                      </b>
                    </td>
                  </tr>
                )}
                {transactionType === 'DEATH CERTIFICATE' && (
                  <tr>
                    <td className="text-dark" colSpan={spanGap}>
                      Place of Death
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_death_municipality_name')
                        )}
                        ,{' '}
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_death_province_name')
                        )}
                        ,{' '}
                        {convertToUpperCase(
                          _.get(taxpayer, 'place_of_death_region_name')
                        )}{' '}
                      </b>
                    </td>
                  </tr>
                )}
              </>
            )}

            {transactionType === 'BIRTH CERTIFICATE' && (
              <>
                <tr className='mt-3'>
                  <td width="350">
                    <span className="title" style={{ fontSize: '16px' }}>
                      DOCUMENT OWNER MOTHER'S NAME
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    First Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{convertToUpperCase(get(taxpayer, 'mothers_first_name'))}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Middle Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{convertToUpperCase(get(taxpayer, 'mothers_middle_name'))}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Last Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{convertToUpperCase(get(taxpayer, 'mothers_last_name'))}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Extension Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'mothers_extension_name'))}
                    </b>
                  </td>
                </tr>

                <tr className='mt-3'>
                  <td width="350">
                    <span className="title" style={{ fontSize: '16px' }}>
                      DOCUMENT OWNER FATHER'S NAME
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    First Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'fathers_first_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Middle Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'fathers_middle_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Last Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'fathers_last_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Extension Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'fathers_suffix_name'))}
                    </b>
                  </td>
                </tr>
              </>
            )}
            {transactionType === 'MARRIAGE CERTIFICATE' && (
              <>
                <tr>
                  <td className="text-primary" colSpan={spanGap}>
                    <b>Man/Husband's Name</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    First Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'husband_first_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Middle Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'husband_middle_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Last Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'husband_last_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Extension Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'husband_extension_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-primary" colSpan={spanGap}>
                    <b>Lady/Wife's Maiden Name</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    First Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'wife_first_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Middle Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'wife_middle_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Last Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'wife_last_name'))}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" colSpan={spanGap}>
                    Extension Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td>
                    <b>
                      {convertToUpperCase(_.get(taxpayer, 'wife_extension_name'))}
                    </b>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

DocumentInformation.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

DocumentInformation.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default DocumentInformation;
